// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__86nJ2","cartAmount":"Cart_cartAmount__CY8bF","cartBtn":"Cart_cartBtn__DQzH6","noItems":"Cart_noItems__xrAow","cart-item":"Cart_cart-item__+tsDy"};